import { Avatar, File, RegisteredUser, Room, RoomMessage, RoomMessageType, Story } from "../proto/Global_pb";
import { InfoLocationResponse } from "../proto/InfoLocation_pb";
import i18next from "i18next";
import { AxiosResponse } from "axios";
import { StickerType } from "../containers/popup/popup-sticker-group";
import { OperatorType } from "../libs/numbers";
import { InfoConfigResponse } from "../proto/InfoConfig_pb";
import React from "react";
import { getStorage } from "../libs/storage";
import { STORAGE_USER_ID } from "./localstorage";

export const emptyImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
export const CHARACTER_LIMIT = 4000;
export const FILE_CHARACTER_LIMIT = 1024;
export const ACTION_ID_RANGE = [11111111, 99999999];

export const protoInfoLocation: InfoLocationResponse.AsObject = {
  isoCode: "IR",
  callingCode: 98,
  name: "Iran",
  pattern: "XXX XXX XXXX",
  regex: "^\\d{10}$",
};

// prettier-ignore
export const countryCodes = ["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AR", "AS", "AT", "AU", "AW", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BW", "BY", "BZ", "CA", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GT", "GU", "GW", "GY", "HK", "HN", "HR", "HT", "HU", "ID", "IE", "IN", "IO", "IQ", "IR", "IS", "IT", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "US", "UY", "UZ", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YL", "ZA", "ZM", "ZW"];
// prettier-ignore
export const countries :{[key in string] : string} = { ad: "Andorra", ae: "United Arab Emirates", af: "Afghanistan", ag: "Antigua & Barbuda", ai: "Anguilla", al: "Albania", am: "Armenia", ao: "Angola", ar: "Argentina", as: "American Samoa", at: "Austria", au: "Australia", aw: "Aruba", az: "Azerbaijan", ba: "Bosnia & Herzegovina", bb: "Barbados", bd: "Bangladesh", be: "Belgium", bf: "Burkina Faso", bg: "Bulgaria", bh: "Bahrain", bi: "Burundi", bj: "Benin", bm: "Bermuda", bn: "Brunei Darussalam", bo: "Bolivia", bq: "Bonaire, Sint Eustatius & Saba", br: "Brazil", bs: "Bahamas", bt: "Bhutan", bw: "Botswana", by: "Belarus", bz: "Belize", ca: "Canada", cd: "Congo (Dem. Rep.)", cf: "Central African Rep.", cg: "Congo (Rep.)", ch: "Switzerland", ci: "Cote d`Ivoire", ck: "Cook Islands", cl: "Chile", cm: "Cameroon", cn: "China", co: "Colombia", cr: "Costa Rica", cu: "Cuba", cv: "Cape Verde", cw: "Curacao", cy: "Cyprus", cz: "Czech Republic", de: "Germany", dj: "Djibouti", dk: "Denmark", dm: "Dominica", do: "Dominican Rep.", dz: "Algeria", ec: "Ecuador", ee: "Estonia", eg: "Egypt", er: "Eritrea", es: "Spain", et: "Ethiopia", fi: "Finland", fj: "Fiji", fk: "Falkland Islands", fm: "Micronesia", fo: "Faroe Islands", fr: "France", ga: "Gabon", gb: "United Kingdom", gd: "Grenada", ge: "Georgia", gf: "French Guiana", gh: "Ghana", gi: "Gibraltar", gl: "Greenland", gm: "Gambia", gn: "Guinea", gp: "Guadeloupe", gq: "Equatorial Guinea", gr: "Greece", gt: "Guatemala", gu: "Guam", gw: "Guinea-Bissau", gy: "Guyana", hk: "Hong Kong", hn: "Honduras", hr: "Croatia", ht: "Haiti", hu: "Hungary", id: "Indonesia", ie: "Ireland", in: "India", io: "Diego Garcia", iq: "Iraq", ir: "Iran", is: "Iceland", it: "Italy", jm: "Jamaica", jo: "Jordan", jp: "Japan", ke: "Kenya", kg: "Kyrgyzstan", kh: "Cambodia", ki: "Kiribati", km: "Comoros", kn: "Saint Kitts & Nevis", kp: "North Korea", kr: "South Korea", kw: "Kuwait", ky: "Cayman Islands", kz: "Kazakhstan", la: "Laos", lb: "Lebanon", lc: "Saint Lucia", li: "Liechtenstein", lk: "Sri Lanka", lr: "Liberia", ls: "Lesotho", lt: "Lithuania", lu: "Luxembourg", lv: "Latvia", ly: "Libya", ma: "Morocco", mc: "Monaco", md: "Moldova", me: "Montenegro", mg: "Madagascar", mh: "Marshall Islands", mk: "Macedonia", ml: "Mali", mm: "Myanmar", mn: "Mongolia", mo: "Macau", mp: "Northern Mariana Islands", mq: "Martinique", mr: "Mauritania", ms: "Montserrat", mt: "Malta", mu: "Mauritius", mv: "Maldives", mw: "Malawi", mx: "Mexico", my: "Malaysia", mz: "Mozambique", na: "Namibia", nc: "New Caledonia", ne: "Niger", nf: "Norfolk Island", ng: "Nigeria", ni: "Nicaragua", nl: "Netherlands", no: "Norway", np: "Nepal", nr: "Nauru", nu: "Niue", nz: "New Zealand", om: "Oman", pa: "Panama", pe: "Peru", pf: "French Polynesia", pg: "Papua New Guinea", ph: "Philippines", pk: "Pakistan", pl: "Poland", pm: "Saint Pierre & Miquelon", pr: "Puerto Rico", ps: "Palestine", pt: "Portugal", pw: "Palau", py: "Paraguay", qa: "Qatar", re: "Reunion", ro: "Romania", rs: "Serbia", ru: "Russian Federation", rw: "Rwanda", sa: "Saudi Arabia", sb: "Solomon Islands", sc: "Seychelles", sd: "Sudan", se: "Sweden", sg: "Singapore", sh: "Saint Helena", si: "Slovenia", sk: "Slovakia", sl: "Sierra Leone", sm: "San Marino", sn: "Senegal", so: "Somalia", sr: "Suriname", ss: "South Sudan", st: "Sao Tome & Principe", sv: "El Salvador", sx: "Sint Maarten", sy: "Syria", sz: "Swaziland", tc: "Turks & Caicos Islands", td: "Chad", tg: "Togo", th: "Thailand", tj: "Tajikistan", tk: "Tokelau", tl: "Timor-Leste", tm: "Turkmenistan", tn: "Tunisia", to: "Tonga", tr: "Turkey", tt: "Trinidad & Tobago", tv: "Tuvalu", tw: "Taiwan", tz: "Tanzania", ua: "Ukraine", ug: "Uganda", us: "USA", uy: "Uruguay", uz: "Uzbekistan", vc: "Saint Vincent & the Grenadines", ve: "Venezuela", vg: "British Virgin Islands", vi: "US Virgin Islands", vn: "Vietnam", vu: "Vanuatu", wf: "Wallis & Futuna", ws: "Samoa", ye: "Yemen", yl: "Y-land", za: "South Africa", zm: "Zambia", zw: "Zimbabwe", };

export const mediaTypes = [
  RoomMessageType.IMAGE,
  RoomMessageType.IMAGE_TEXT,
  RoomMessageType.VIDEO,
  RoomMessageType.VIDEO_TEXT,
  RoomMessageType.AUDIO,
  RoomMessageType.AUDIO_TEXT,
  RoomMessageType.VOICE,
  RoomMessageType.GIF,
  RoomMessageType.GIF_TEXT,
  RoomMessageType.FILE,
  RoomMessageType.FILE_TEXT,
];

export enum AdditionalType {
  NONE,
  UNDER_KEYBOARD_BUTTON,
  UNDER_MESSAGE_BUTTON,
  BUTTON_CLICK_ACTION,
  STICKER,
  GIF,
  STREAM_TYPE,
  KEYBOARD_TYPE,
  FORM_BUILDER,
  WEBVIEW_SHOW,
  REQUEST_PHONE,
  REQUEST_LOCATION,
  CARD_TO_CARD_MESSAGE,
  GIFT_STICKER,
}
export enum News {
  SLIDER = "5",
  BANNER = "0",
  MULTI_BUTTON = "2",
  BUTTON = "1",
}
export enum Bills {
  GAS = "GAS",
  PHONE = "PHONE",
  MOBILE_MCI = "MOBILE_MCI",
  ELECTRICITY = "ELECTRICITY",
}

export interface AdditionalData {
  label: string;
  value: string | any;
  imageUrl: string;
  actionType: ActionTypes;
}

export enum LocalesType {
  FA = "fa-IR",
  EN = "en-US",
  AR = "ar-UA",
}

export interface ClientSearchInfoType {
  users?: Array<RegisteredUser.AsObject>;
  contacts?: Array<RegisteredUser.AsObject>;
  channels?: Array<Room.AsObject>;
  groups?: Array<Room.AsObject>;
}
export type ChatSearchDataType = {
  mine: ClientSearchInfoType;
  global: ClientSearchInfoType;
  isIdle: boolean;
  dataNotFound: boolean;
};

export enum sharedMediaTypes {
  SharedImages = "room_info_popup.shared_image",
  SharedVideo = "room_info_popup.shared_video",
  SharedAudio = "room_info_popup.shared_audio",
  SharedVoice = "room_info_popup.shared_voice",
  SharedGif = "room_info_popup.shared_gif",
  SharedFile = "room_info_popup.shared_file",
  SharedUrl = "room_info_popup.shared_url",
}

export const getCloudAvatar = (user?: RegisteredUser.AsObject) => {
  if (!user || user.id === getStorage(STORAGE_USER_ID))
    return {
      id: "",
      file: {
        publicUrl: "/cloud.png",
        token: "",
        name: "",
        size: 0,
        width: 0,
        height: 0,
        duration: 0,
        cacheId: "",
        mime: "image/png",
      },
    };
  return user.avatar;
};
export const cloudUserData = (user: RegisteredUser.AsObject): RegisteredUser.AsObject => {
  if (user.id === getStorage(STORAGE_USER_ID))
    return {
      ...user,
      // displayName: i18next.t("global.cloud"),
      status: RegisteredUser.Status.RECENTLY,
      avatar: getCloudAvatar(user),
    };
  return user;
};

export enum RoadmapDataType {
  DONE = "done",
  DOING = "doing",
  TODO = "todo",
}

export type DynamicDataType<T> = {
  data?: T;
  isLoading?: boolean;
  isError?: boolean;
};

export type CheckOrderFeature = {
  ceil: number;
  discount: number;
  floor: number;
  plus: number;
  spent: number;
  title: string;
  type: string;
  unit: number;
  userScore: number;
  priceWithFeature: number;
};

export type CheckOrderResponseType = AxiosResponse<{
  features: Array<CheckOrderFeature>;
  info: {
    campaign?: {
      discount: number;
      discountAmount: number;
      id: string;
      name: string;
      priceAfterDiscount: number;
      token: string;
    };
    order_id: string;
    price: number;
    product?: {
      description: string;
      product_id: string;
      provider_id: string;
      refType: string;
      ref_id: string;
      ref_type: string;
      tel_charger: string;
      tel_num: string;
      title: string;
      type: string;
      vendor: string;
    };
  };
  redirect_url: string;
}>;

export type GetInfoObject = {
  type: "string";
  title: "string";
};
export type GetInfoResponseType = AxiosResponse<{
  data: Array<GetInfoObject>;
}>;

export type GetBillsResponseType = {
  docs: Array<BillInquiryType>;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  nextPage: null;
  offset: number;
  page: number;
  pagingCounter: number;
  prevPage: null;
  totalDocs: number;
  totalPages: number;
};

export type BillInquiryType = {
  bill_identifier: string;
  bill_title: string;
  bill_type: string;
  id: string;
  mobile_number: string;
  subscription_code: string;
  phone_number: string;
  area_code: string;
};

export type ChannelSlideType = {
  action_link: string;
  action_type: number;
  id: string;
  image_url: string;
  title: string;
  title_en: string;
};
export type ChannelItemType = Omit<ChannelSlideType, "action_link" | "action_type" | "image_url"> & {
  icon: string;
  id: string;
  priority: number;
  slug: string;
  title: string;
  title_en: string;
  type: string;
};
export type ChannelCategoryType = Omit<ChannelSlideType, "action_type" | "action_link" | "image_url"> & {
  appId: number;
  icon: string;
  slug: string;
};

export enum ChannelsRowType {
  Advertisement = "advertisement",
  ChannelFeaturedCategory = "channelFeaturedCategory",
  ChannelNormalCategory = "channelNormalCategory",
}

export type ChannelsRow = {
  data_count: number;
  id: string;
  info: {
    looped: boolean;
    playback_time: number;
    scale: string;
    title: string;
    title_en: string;
  };
  playback_time: number;
  scale: string;
  title: string;
  title_en: string;
  slides?: Array<ChannelSlideType>;
  channels?: Array<ChannelItemType>;
  categories?: Array<ChannelCategoryType>;
  type: ChannelsRowType;
};
export type GetChannelsType = {
  data: Array<ChannelsRow>;
};

export type StickerGiftFirstMessageDatatype = {
  action_link: string;
  action_type: string;
  image_url: string;
  title: string;
  title_en: string;
};
export type StickerGiftFirstMessageType = {
  data: Array<StickerGiftFirstMessageDatatype>;
  info: {
    title: string;
    title_en: string;
  };
};

export type CheckMobileNumberResponseType = {
  success: boolean;
};

export type GiftStickerResponseDatatype = {
  _id: string;
  avatarName: string;
  avatarSize: number;
  avatarToken: string;
  isGiftable: boolean;
  isInUserList: boolean;
  isNew: boolean;
  isReadonly: boolean;
  isVip: boolean;
  name: string;
  price: number;
  refId: number;
  sort: number;
  status: string;
  type: string;
  stickers: Array<StickerType>;
};

export type MyGiftStickerList = {
  activation: {
    status: string;
    mobileNumber?: string;
    nationalCode?: string;
    userId?: string;
  };
  activationStatus: "NEW" | "FORWARDED" | "ACTIVE";
  amount: number;
  creation: { status: string };
  id: string;
  requestCount: number;
  rrn: number;
  sticker: StickerType;
  toUserId: null | RegisteredUser.AsObject["id"];
  createdAt: string;
};

export enum internetPackageEnum {
  Credit = "CREDIT",
  Permanent = "PERMANENT",
  Data = "DATA",
  CreditTdLte = "CREDIT_TD_LTE",
  Permanent_Td_Lte = "PERMANENT_TD_LTE",
  CreditPermanent = "CREDIT_PERMANENT",
}

export enum locationPermission {
  Granted = "granted",
  Denied = "denied",
  Data = "DATA",
  CreditTdLte = "CREDIT_TD_LTE",
  Permanent_Td_Lte = "PERMANENT_TD_LTE",
  CreditPermanent = "CREDIT_PERMANENT",
}

export type internetPackageObjectType = {
  type: internetPackageEnum;
  title: string;
  operators: Array<OperatorType>;
};

export type ProvinceList = {
  country_name: string;
  id: number;
  english_name: string;
  province_name: string;
  country_id: number;
};

export type GetProvinceList = {
  data: Array<ProvinceList>;
};

export type LocationSearch = {
  warehoff: boolean;
  id: number;
  accounts: [];
  city_name: string;
  location_priority: number;
  longitude: number;
  payment_id: string;
  location_name: string;
  has_QR: boolean;
  bulky_sale: boolean;
  text: {
    english_top_text: string;
    top_text: string;
    english_bottom_text: string;
    bottom_text: string;
    id: number;
  };
  description: string;
  activation: boolean;
  location_english_name: string;
  introduction: string;
  project_id: number;
  print_pos: boolean;
  latitude: number;
  mandatory_entrance: boolean;
  location_english_address: string;
  location_address: string;
  extra: {
    ShortDescription: string;
    FullDescription: string;
    Lat: string;
    Long: string;
    CoverImage: string;
    Gallery: [
      {
        url: string;
      }
    ];
  };
};

export type GetLocationSearch = {
  data: Array<LocationSearch>;
};

export type InternetPackagesGetCategorized = {
  chargeType: number;
  cost: number;
  description: string;
  duration: string;
  isSpecial: true;
  traffic: string;
  type: string;
  in_network_conversation?: string;
  in_network_sms?: string;
  out_network_conversation?: string;
  out_network_sms?: string;
};

export type EntertainmentService = {
  beneficiary_iban: string;
  service_id: number;
  service_name: string;
  english_name: string;
  description: string;
  location_id: number;
  type_of_service_sale: string;
  activation: boolean;
  service_times?: [];
  beneficiary_payment_id: string;
  capacity: string;
  type_amounts: [
    {
      languages: [
        {
          language_name: string;
        }
      ];
      amount_without_discount: number;
      voucher_capacity: string;
      voucher_type: string;
      english_name: string;
      amount: number;
      total_discount_percentage: number;
      voucher_type_id: number;
      is_free: boolean;
      voucherinfo_id: number;
    }
  ];
  model_id: string;
  location_name: string;
  model_name: string;
  normal_sale: boolean;
};

export type GetEntertainmentService = {
  data: Array<EntertainmentService>;
};

export enum FileStatus {
  Downloading = "DOWNLOADING",
  DOWNLOADED = "DOWNLOADED",
  Uploading = "UPLOADING",
  Canceled = "CANCELED",
  PAUSED = "PAUSED",
  DEFAULT = "DEFAULT",
}

export const asideTabs = {
  CHAT: InfoConfigResponse.Tab.CHAT,
  CONTACT: InfoConfigResponse.Tab.CONTACT,
  SETTING: InfoConfigResponse.Tab.SETTING,
  ILAND: InfoConfigResponse.Tab.ILAND,
  CALL: InfoConfigResponse.Tab.CALL,
  STORY: 5,
};

export type QrCodeResponse = {
  merchant_name: string;
  pcqr: boolean;
  qr_code: string;
};

export enum AdditionalTypes {
  ADDITIONAL_TYPE_NONE,
  ADDITIONAL_TYPE_UNDER_KEYBOARD_BUTTON,
  ADDITIONAL_TYPE_UNDER_MESSAGE_BUTTON,
  ADDITIONAL_TYPE_BUTTON_CLICK_ACTION,
  ADDITIONAL_TYPE_STICKER,
  ADDITIONAL_TYPE_GIF,
  ADDITIONAL_TYPE_STREAM_TYPE,
  ADDITIONAL_TYPE_KEYBOARD_TYPE,
  ADDITIONAL_TYPE_FORM_BUILDER,
  ADDITIONAL_TYPE_WEBVIEW_SHOW,
}

export enum ActionTypes {
  BUTTON_ACTION_JOIN_LINK = 1,
  BUTTON_ACTION_BOT_ACTION,
  BUTTON_ACTION_USERNAME_LINK,
  BUTTON_ACTION_WEB_LINK,
  BUTTON_ACTION_WEBVIEW_LINK,
  BUTTON_ACTION_STREAM_PLAY,
  BUTTON_ACTION_PAY_BY_WALLET,
  BUTTON_ACTION_PAY_DIRECT,
  BUTTON_ACTION_REQUEST_PHONE,
  BUTTON_ACTION_REQUEST_LOCATION,
  BUTTON_ACTION_SHOW_ALERT,
  BUTTON_ACTION_PAGE,
  BUTTON_ACTION_FINANCIAL_MENU,
  BUTTON_ACTION_BILL_MENU,
  BUTTON_ACTION_TRAFFIC_BILL_MENU,
  BUTTON_ACTION_MOBILE_BILL_MENU,
  BUTTON_ACTION_PHONE_BILL_MENU,
  BUTTON_ACTION_TOPUP_MENU,
  BUTTON_ACTION_WALLET_MENU,
  BUTTON_ACTION_NEARBY_MENU,
  BUTTON_ACTION_CALL,
  BUTTON_ACTION_STICKER_SHOP,
  BUTTON_ACTION_IVAN,
  BUTTON_ACTION_IVANQR,
  BUTTON_ACTION_IVANDLIST,
  BUTTON_ACTION_IVANDSCORE,
  BUTTON_ACTION_CARD_TO_CARD,
}

export enum StoryPages {
  HOME,
  MY_STORIES,
}

export enum TitleType {
  VIEWS,
  MY_MOMENT,
  NAME,
}

export interface MediaWrapperContextType {
  inCache: boolean;
  progress: number;
  fileSize: File.AsObject["size"] | string;
  fileStatus: FileStatus;
  download: () => Promise<void>;
  cancelDownload: () => void;
  pauseUpload: (e: React.MouseEvent<HTMLElement>) => void;
  continueUpload?: (e: React.MouseEvent<HTMLElement>) => void;
  cancelUpload?: (e: React.MouseEvent<HTMLElement>) => void;
  setFileStatus?: (fileStatus: FileStatus) => void;
  file?: RoomMessage.AsObject["attachment"];
  fileUrl?: string;
  thumbnail?: string;
  messageType?: RoomMessage.AsObject["messageType"];
  messageId?: RoomMessage.AsObject["messageId"];
}

export enum AudioStatus {
  PLAYING = "PLAYING",
  PAUSED = "PAUSED",
}

export enum AccountDetector {
  NEW = "NEW",
  FIND = "FIND",
}

export enum RoomFilter {
  All = -1,
  ExpertGroup = Room.Type.GROUP,
  ExpertChannel = Room.Type.CHANNEL,
  Chat = Room.Type.CHAT,
}

export abstract class MockAbstract {
  abstract handle(): void;
}

declare global {
  interface Window {
    Config: {
      debugMode: boolean;
    };
    Cypress: Object | undefined;
  }
}
window.Config = window.Config || { debugMode: false };

export const defaultInfoLocation = {
  isoCode: "IR",
  callingCode: 98,
  name: "Iran",
  pattern: "XXX XXX XXXX",
  regex: "^\\d{10}$",
};

export enum StickerFilterGroupTypes {
  ANIMATED = "ANIMATED",
  GIF = "GIF",
  ORDINARY = "ORDINARY",
  ALL = "ALL",
}

export interface clickStoryType {
  (roomId: RoomMessage.AsObject["roomId"] | undefined, userId: RegisteredUser.AsObject["id"] | undefined, avatarId: Avatar.AsObject["id"] | undefined, storyId: Story.AsObject["id"] | undefined): void;
}

export enum AvatarSizeType {
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export enum FetchingStatus {
  Idle = "IDLE",
  Loading = "LOADING",
  Resolved = "RESOLVED",
  Rejected = "REJECTED",
}

export type Fetching<T> = T & { fetchingStatus: FetchingStatus };
